import type { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './EmptyState.module.scss';

export interface EmptyStateProps {
  /** Icon rendered above the title */
  icon?: ReactNode;
  /** Heading text */
  title: string;
  /** Description text */
  description?: string;
  /** Call-to-action button or link */
  action?: ReactNode;
  /** Additional class name */
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.container, className)}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
